import { Button, Select } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import "./GestionMaestras.scss";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";

export const GestionarMaestras = () => {
  const navigate = useNavigate();
  const [selectOption, setSelectOption] = useState("");
  const goScreen = () => {
    if (selectOption !== "") {
      return navigate(`/administrador/${selectOption}`);
    }
  };
  const routes = [{ nombre: "Administración" },{ nombre: "Gestionar maestras" },{ nombre: "Convocatorias" }];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c6">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Gestionar maestra de convocatorias
        </div>
        <div className="sombra_card" style={{ marginBottom: "50px" }}>
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
              Seleccionar maestra
            </div>
          </div>
          <div className="body_card">
            <div className="row">
              <span className="label-select">Seleccionar Maestra</span>

              <div className="col-12">
                <Select
                suffixIcon={<FlechaSelect />}
                  className="select"
                  placeholder="Seleccionar"
                  style={{ width: "100%" }}
                  // showSearch
                  onChange={(value: string) => setSelectOption(value)}
                  // filterOption={(input, option: any) =>
                  //   option.children
                  //     .toLowerCase()
                  //     .indexOf(input.toLowerCase()) >= 0
                  // }
                  // filterSort={(optionA, optionB) =>
                  //   optionA.children
                  //     .toLowerCase()
                  //     .localeCompare(optionB.children.toLowerCase())
                  // }
                >
                  <Select.Option value="gestionarLineasCategorias">
                    Línea y categoría
                  </Select.Option>
                  <Select.Option value="gestionarActividadesCronograma">
                    Actividades cronograma
                  </Select.Option>
                  <Select.Option value="gestionarDocumentosAdministrativos">
                    Documentos administrativos
                  </Select.Option>
                  <Select.Option value="gestionarDocumentosTecnicos">
                    Documentos técnicos
                  </Select.Option>
                  <Select.Option value="gestionarEntidad">
                    Entidad
                  </Select.Option>
                  <Select.Option value="gestionarCiclos">Ciclo</Select.Option>
                  <Select.Option value="gestionarAreas">Expresión</Select.Option>
                  <Select.Option value="gestionarLineaEstrategica">
                    Línea estratégica
                  </Select.Option>
                  {/* <Select.Option value="">Expresiones y categorias</Select.Option> */}
                </Select>
              </div>
            </div>
          </div>
          <div className="footer_card">
            <div className="col-12">
              <div className="d-flex justify-content-end">
                <Button onClick={goScreen} className="button-azul-radius m-0">
                  Continuar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
